import Axios from "axios";
var GoodService = (function () {
    function GoodService() {
    }
    GoodService.prototype.getGroups = function (params) {
        return Axios.get("supplierclientapi/customer/group_list", { params: params });
    };
    GoodService.prototype.getGoodList = function (params) {
        return Axios.get("supplierclientapi/suppliergoods/list", { params: params });
    };
    GoodService.prototype.getBusinessGoodList = function (params) {
        return Axios.get("supplierclientapi/customer/business_goods_list", { params: params });
    };
    GoodService.prototype.getStatus = function (params) {
        return Axios.get("basicapi/auditstatus", { params: params });
    };
    GoodService.prototype.getCategory = function (params) {
        return Axios.get("supplierclientapi/suppliergoodstype/type_list", { params: params });
    };
    GoodService.prototype.getBrand = function (params) {
        return Axios.get("/basicapi/goodbrand", { params: params });
    };
    GoodService.prototype.getStorage = function (params) {
        return Axios.get("basicapi/storagecondition", { params: params });
    };
    GoodService.prototype.getStorageTemperatureRange = function (params) {
        return Axios.get("basicapi/storage_condition_temperature_range", { params: params });
    };
    GoodService.prototype.getExpUnit = function (params) {
        return Axios.get("supplierclientapi/suppliergoods/exp_map", { params: params });
    };
    GoodService.prototype.getArea = function (params) {
        return Axios.get("basicapi/area", { params: params });
    };
    GoodService.prototype.getUnit = function (params) {
        return Axios.get("basicapi/goodunit", { params: params });
    };
    GoodService.prototype.getAttr = function (params) {
        return Axios.get("supplierclientapi/suppliergoods/get_goods_attr", { params: params });
    };
    GoodService.prototype.getCheckType = function (params) {
        return Axios.get("supplierclientapi/suppliergoods/get_goods_check_type", { params: params });
    };
    GoodService.prototype.getCateringType = function (params) {
        return Axios.get("/basicapi/cateringtype", { params: params });
    };
    GoodService.prototype.getCookType = function (params) {
        return Axios.get("/basicapi/cooktype", { params: params });
    };
    GoodService.prototype.getTaste = function (params) {
        return Axios.get("/basicapi/taste", { params: params });
    };
    GoodService.prototype.getFlavor = function (params) {
        return Axios.get("/basicapi/flavor", { params: params });
    };
    GoodService.prototype.goodAddSave = function (params) {
        return Axios.post("/supplierclientapi/suppliergoods/save", params);
    };
    GoodService.prototype.getGoodInfor = function (params) {
        return Axios.get("supplierclientapi/suppliergoods/edit", { params: params });
    };
    GoodService.prototype.delGood = function (params) {
        return Axios.get("supplierclientapi/suppliergoods/del", { params: params });
    };
    GoodService.prototype.downupGood = function (params) {
        return Axios.get("/supplierclientapi/suppliergoods/uptomall", { params: params });
    };
    GoodService.prototype.getGoodDetail = function (params) {
        return Axios.get("supplierclientapi/suppliergoods/show", { params: params });
    };
    GoodService.prototype.getPinyin = function (params) {
        return Axios.get("basicapi/getpinyin", { params: params });
    };
    GoodService.prototype.setCategory = function (params) {
        return Axios.get("supplierclientapi/suppliergoods/goods_move", { params: params });
    };
    GoodService.prototype.setSupplierUpper = function (params) {
        return Axios.post("supplierclientapi/suppliergoods/set_supplier_upper", params);
    };
    GoodService.prototype.saveGoodsFormat = function (params) {
        return Axios.post("supplierclientapi/suppliergoods/save_goods_format", params);
    };
    GoodService.prototype.deleteGoodsFormat = function (params) {
        return Axios.post("supplierclientapi/suppliergoods/del_goods_format", params);
    };
    GoodService.prototype.getGoodListAllFormat = function (params) {
        return Axios.post("supplierclientapi/suppliergoods/get_list", params);
    };
    GoodService.prototype.getCheck = function (params) {
        return Axios.get("supplierclientapi/suppliergoodstype/check", { params: params });
    };
    GoodService.prototype.getGoodFormatList = function (params) {
        return Axios.post("supplierclientapi/suppliergoods/goods_format_list", params);
    };
    GoodService.prototype.getGoodAlreadyBindLicenses = function (params) {
        return Axios.get("supplierclientapi/suppliergoods/document_list", { params: params });
    };
    GoodService.prototype.getGoodAlreadyBindLicensesIds = function (params) {
        return Axios.get("supplierclientapi/suppliergoods/document_ids", { params: params });
    };
    GoodService.prototype.goodBindLicenses = function (params) {
        return Axios.post("supplierclientapi/suppliergoods/bind_document", params);
    };
    GoodService.prototype.goodUnBindLicenses = function (params) {
        return Axios.post("supplierclientapi/suppliergoods/unbind_document", params);
    };
    GoodService.prototype.getSupplierdepotOptions = function (params) {
        return Axios.get("supplierclientapi/supplierdepot/get_options", { params: params });
    };
    GoodService.prototype.updateGoodsSort = function (params) {
        return Axios.post("supplierclientapi/suppliergoods/sort", params);
    };
    GoodService.prototype.toggleMallGoodsStatus = function (params) {
        return Axios.post("supplierclientapi/suppliergoods/shopping_publish", params);
    };
    GoodService.prototype.getTaxiByGoodsName = function (params) {
        return Axios.post("supplierclientapi/suppliergoods/goods_tax_type_recommend", params);
    };
    GoodService.createInstance = function () {
        GoodService.getInstance();
    };
    GoodService.getInstance = function () {
        return this._instance || (this._instance = new this());
    };
    return GoodService;
}());
export default GoodService;
